<template>
  <div class="daily-container">
    <van-nav-bar title="日报" left-arrow @click-left="onClickLeft" />
    <div class="daily-content">
      <ul class="search-tabs" @click="changeTitle">
        <li id="0">我的</li>
        <li id="1">我审核的</li>
        <li id="2">抄送我的</li>
        <li id="3">公开的</li>
      </ul>
      <div class="daily-search">
        <div @click="changeTime">{{ currentDateStr }}</div>
        <van-dropdown-menu>
          <van-dropdown-item
            @change="changeStatus"
            v-model="typeValue"
            :options="typeOption"
          />
        </van-dropdown-menu>
      </div>
      <van-search v-model="searchValue" show-action placeholder="请输入姓名">
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
      <div
        class="daily-item"
        @click="handleClick(item)"
        v-for="(item, index) in taskList"
        :key="index"
      >
        <div class="member-info">
          <img v-if="handleAvatar(item)" style="width: 40px;height: 40px;margin-right: 8px" :src="item.avatar" />
          <div v-else class="member-bg">{{renderName(item.staffName)}}</div>
          <div>
            <div>{{ item.staffName }}</div>
            <div>部门：{{ item.officeName }}</div>
            <div>职位：{{ item.position }}</div>
          </div>
        </div>
        <div
          :style="handleColor(item, index)"
        >
          {{ handelRender(item) }}
        </div>
      </div>
      <div class="daily-footer">
        <div class="daily-submit" @click="jumpEdit">写日报</div>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        @confirm="(data) => onConfirm(data)"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { setMainStaff, getTaskList } from "../axios/services";
import { mapState } from "vuex";
import { Toast } from "vant";
export default {
  data() {
    return {
      searchValue: "",
      typeValue: 3,
      typeOption: [
        { text: "未填写", value: 0 },
        { text: "未审核", value: 1 },
        { text: "已审核", value: 2 },
        { text: "全部", value: 3 },
      ],
      showPicker: false,
      currentDate: new Date(),
      currentDateStr: this.handleTime(new Date()),
      taskList: [],
      conditionType: "3",
      searchWord: "",
      // color: ''
    };
  },
  computed: {
    ...mapState(["initialData", "dailyData"]),
  },
  methods: {
    onClickLeft() {
      window.location.href = "jsToOc://back";
    },
    handleTime(date) {
      return (
        date.getFullYear() +
        "-" +
        this.checkTime(date.getMonth() + 1) +
        "-" +
        this.checkTime(date.getDate())
      );
    },
    checkTime(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
    changeTime() {
      this.showPicker = true;
    },
    changeStatus() {
      this.getList();
    },
    onConfirm(date) {
      this.currentDateStr = this.handleTime(date);
      this.showPicker = false;
      this.getList();
    },
    changeTitle(e) {
      const liList = document.querySelectorAll("li");
      if (e.target.id !== "" && e.target.id === "0") {
        liList[0].classList.add("active");
        liList[1].classList.remove("active");
        liList[2].classList.remove("active");
        liList[3].classList.remove("active");
        this.conditionType = "3";
        this.getList();
      }
      if (e.target.id !== "" && e.target.id === "1") {
        liList[1].classList.add("active");
        liList[0].classList.remove("active");
        liList[2].classList.remove("active");
        liList[3].classList.remove("active");
        this.conditionType = "4";
        this.getList();
      }
      if (e.target.id !== "" && e.target.id === "2") {
        liList[2].classList.add("active");
        liList[0].classList.remove("active");
        liList[1].classList.remove("active");
        liList[3].classList.remove("active");
        this.conditionType = "5";
        this.getList();
      }
      if (e.target.id !== "" && e.target.id === "3") {
        liList[3].classList.add("active");
        liList[0].classList.remove("active");
        liList[1].classList.remove("active");
        liList[2].classList.remove("active");
        this.conditionType = "0";
        this.getList();
      }
    },
    handleColor(item, index) {
      let color = "";
      if (item.taskStatus==0) {
        return color = "color:#FFBE25";
      }
      if (item.taskStatus==1&&item.isSendToMe==0) {
        return color = "color:#FE773C";
      }
      if (item.taskStatus==1&&item.isSendToMe==1) {
        return color = "color:#1E1E1E";
      }
      if (item.taskStatus==2) {
        return color = "color:#1AA15F";
      }
      if (item.taskStatus==3) {
        return color = "color:#23AAF2";
      }
      return color;
    },
    handelRender(item) {
      let str = "";
      switch (item.taskStatus) {
        case 0:
          str = "未填写";
          break;
        case 1:
          str = "未审核";

          break;
        case 2:
          str = "已审核";
          break;
          case 4:
          str = "休息";
          break;
          case 5:
          str = "查看";
          break;
          case 6:
          str = "未排班";
          break;
          case 7:
          str = "请假";
          break;
          case 8:
          str = "未入职";
          break;
        default:
          str = "";
          break;
      }
      return str;
    },
    onSearch() {
      this.getList();
    },
    jumpEdit() {
      this.$router.push("/daily-edit");
    },
    handleClick(item) {
      if (item.staffId === this.dailyData.staffId) {
        
        if (item.taskStatus === 0||item.taskStatus==4){
          this.$router.push("/daily-edit");
        }
        if (item.taskStatus == 2 && item.reportId) {
          this.$router.push(`daily-detail/${item.reportId}`);
        } 
        if (item.taskStatus === 6||item.taskStatus === 7||item.taskStatus === 8) {
          Toast("该日期为休息日，无法查看日报");
        }else {
          // this.$router.push(`/daily-edit/reportId=${item.reportId}&companyId=${item.companyId}`)
          this.$router.push({
            path: "/daily-edit",
            query: { reportId: item.reportId, companyId: item.companyId,currentDateStr:this.currentDateStr },
          });
        }
      } else if (
        item.staffId !== this.dailyData.staffId &&
        item.reportId &&
        item.isView === 0&&item.isSendToMe==0
      ) {
        this.$router.push(`daily-detail/${item.reportId}`);
      } else {
        Toast("该用户还没有填写日报,或者无权限，无法查看");
      }
    },
    getList() {
      const data = {
        companyId: this.dailyData.companyId,
        reportDate: this.currentDateStr,
        conditionType: this.conditionType,
        searchWord: this.searchValue,
        reportStatus: this.typeValue,
      };
      getTaskList(data).then((res) => {
        if (res.data.code === 0) {
          this.taskList = res.data.data;
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    setInitdata() {
      const params = {
        companyId: this.initialData.companyId,
      };
      setMainStaff(params).then((res) => {
        if (res.data.code === 0) {
          this.$store.commit("setDailyData", res.data.data);
          this.getList();
        } else {
          Toast.fail(res.data.msg);
        }
      })
    },
    handleAvatar(item) {
      return item.avatar && item.avatar.slice(0,4) == 'http' ? true : false
    },
    renderName(name) {
      let str = ''
      if(name) {
        if(name.length === 1) {
          str = name
        }
        if(name.length > 1) {
          str = name.substr(-2,2)
        }
      }
      return str
    },
  },
  created() {
    this.setInitdata();
  },
  mounted() {
    const liList = document.querySelectorAll("li");
    liList[0].classList.add("active");
    // for(let i = 0; i < liList.length; i++) {
    //   if(this.conditionType !== '' && i === parseInt(this.conditionType)) {
    //     liList[i].classList.add('active')
    //   }
    //   if(this.conditionType !== '' && i !== parseInt(this.conditionType)) {
    //     liList[i].classList.remove('active')
    //   }
    // }
  },
};
</script>

<style scoped>
  .daily-container {
    width: 100%;
    min-height: 100vh;
    padding-bottom: 2rem;
    background: white;
    position: relative;
  }
  .van-nav-bar /deep/.van-nav-bar__arrow {
    font-size: 22px;
    color: black;
  }
  .van-dropdown-menu {
    width: 3rem;
    /* height: 1rem; */
  }
  .van-dropdown-menu /deep/ .van-dropdown-item__option--active {
    color: #1584FF !important;
  }
  .van-dropdown-menu /deep/ .van-dropdown-menu__title--active {
    color: #1584FF !important;
  }
  .van-dropdown-menu /deep/ .van-dropdown-menu__bar {
    box-shadow: none;
  }
  .van-search {
    background: #f9f9f9;
  }
  .van-search /deep/ .van-field__control {
    background: #ffffff;
  }
  .daily-search {
    display: flex;
    justify-content: space-around;
    align-items: baseline;
    padding: 0 .2rem;
  }
  .search-tabs {
    width: 100%;
    height: .8rem;
    margin-top: 0.3rem;
    display: flex;
    justify-content: space-around;
  }
  .active {
    color: #1584FF
  }
  .daily-item {
    width: 9.6rem;
    height: 2.45rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0.4rem;
    margin-left: 0.4rem;
    border-bottom: 0.03rem solid #F3F3F3;
  }
  .member-info {
    display: flex;
    align-items: flex-start;
  }
  .member-bg {
    width: 40px;
    height: 40px;
    background: #1584FF;
    border-radius: 0.21rem;
    font-size: 0.32rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 40px;
    text-align: center;
    margin-right: 8px
  }
  .daily-submit {
    color: white;
    line-height: 1.17rem;
    text-align: center;
    width: 8.29rem;
    height: 1.17rem;
    background: #1584FF;
    box-shadow: 0rem 0.05rem 0.21rem 0rem #80BCFF;
    border-radius: 0.21rem;
  }
  .daily-footer {
    width: 100%;
    height: 2rem;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>>
